var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "PoseTransition",
        [
          _vm.isShowing
            ? _c(
                "Wrapper",
                {
                  staticClass: "image-lightbox",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.didSelectClose()
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "image-lightbox__overlay",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.didSelectClose()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "container" },
                    [
                      _c(
                        "GalleryBody",
                        { staticClass: "image-lightbox__body" },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "image-lightbox__body__close",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.didSelectClose()
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "sr-only" }, [
                                _vm._v("Close")
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "GalleryImage",
                            { staticClass: "image-lightbox__body__image" },
                            [
                              _c("img", {
                                directives: [
                                  {
                                    name: "lazy",
                                    rawName: "v-lazy",
                                    value: _vm.currentImage.sizes.large,
                                    expression: "currentImage.sizes.large"
                                  }
                                ],
                                class: {
                                  portrait:
                                    _vm.currentImage.height >=
                                    _vm.currentImage.width
                                },
                                attrs: { alt: "currentImage.alt" }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "GalleryToolbar",
                            { staticClass: "image-lightbox__body__toolbar" },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "image-lightbox__body__toolbar__count"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.currentIndex + 1) +
                                      " / " +
                                      _vm._s(_vm.imageData.length)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "image-lightbox__body__toolbar__caption"
                                },
                                [_vm._v(_vm._s(_vm.currentImage.caption))]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                {
                                  staticClass:
                                    "image-lightbox__body__toolbar__navigation"
                                },
                                [
                                  _c("li", [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "image-lightbox__body__toolbar__navigation__previous",
                                        class: { disabled: !_vm.currentIndex },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.didSelectPrevious()
                                          }
                                        }
                                      },
                                      [
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v("Previous")
                                        ])
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "image-lightbox__body__toolbar__navigation__next",
                                        class: {
                                          disabled:
                                            _vm.currentIndex + 1 >=
                                            _vm.imageData.length
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.didSelectNext()
                                          }
                                        }
                                      },
                                      [
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v("Next")
                                        ])
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/vue-loader/lib?{}!./scripts/vue/ImageLightbox.vue?vue&type=template&id=2c902d28&
// module id = 69
// module chunks = 0